export default "__VITE_ASSET__26ngK_YH__"